export const categoriesInRow = 3;
